<style>
.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.innerRegister {
  margin-left: auto;
  margin-right: auto;
  width: 850px;
}
</style>
<template>
  <div id="password-reset-confirm">
    <div :class="{ outer: !$vuetify.breakpoint.mobile }">
      <div :class="{ middle: !$vuetify.breakpoint.mobile }">
        <div :class="{ innerRegister: !$vuetify.breakpoint.mobile }">
          <v-row>
            <v-col>
              <v-card class="rounded-xl" elevation="7">
                <v-form ref="form" class="pa-4 pt-6">
                  <p class="text-center text-h4">Password Reset</p>
                  <v-text-field
                    class="rounded-xl"
                    v-model="password"
                    label="New Password"
                    type="password"
                  ></v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="confirmPassword"
                    label="Confirm New Password"
                    type="password"
                  ></v-text-field>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="rounded-xl"
                      :loading="loading"
                      color="primary"
                      text
                      @click="doResetPassword()"
                    >
                      Reset
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "PasswordResetConfirm",
  data() {
    return {
      password: "",
      confirmPassword: "",
      code: "",
      loading: false
    }
  },
  methods: {
    doResetPassword() {
      this.loading = true
      this.axios
        .put("/api/v1/auth/passwordReset/confirm", {
          code: this.code,
          password: this.password,
          confirmPassword: this.confirmPassword
        })
        .then(() => {
          this.loading = false
          this.$toast.success("Password reset successfully, you can now login.")
          this.$router.push("/dashboard")
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.code = this.$route.params.code
  }
}
</script>

<style scoped></style>
